export class TRCAppForm {

    bus_Desc = ''
    web_Filing_Id = '' 
    web_Confirmation_Nbr = '' 
    busid_Legal_Nm = '' 
    busid_Idcheck = '' 
    busid_Dba_Nm = '' 	
    busact_Start_Dt = '' 
    busact_Bus_Type = '' 
    busact_Seller_Permit = '' 
    busact_Irs_Activity_Cd = '' 
    busact_Irs_Activity_Cd2 = ''
    busact_Irs_Activity_Cd3 =''
	busact_Irs_Activity_Cd4 =''
    buson_Name_First = '' 
    buson_Name_Last = '' 
    buson_Title = '' 
    buson_Phone_Nbr = '' 
    buson_Phone_Ext = '' 
    buson_Email = '' 
    buson_Web_Address = '' 
    filer_Name_First = '' 
    filer_Name_Last = '' 
    filer_Title = '' 
    filer_Phone_Nbr = '' 
    filer_Phone_Ext = '' 
    filer_Email = '' 
    ba0_Commerical = '' 
    ba1_Str_Nbr = '' 
    ba1_Str_Nbr_Frac = '' 
    ba1_Str_Dir_Prefix = '' 
    ba1_Str_Nm = '' 
    ba1_Str_Dir_Suffix = '' 
    ba1_Str_Type = '' 
    ba2_Unit_Type = '' 
    ba2_Unit_Nbr = '' 
    ba2_CareOf = '' 
    ba3_City = '' 
    ba3_State = '' 
    ba3_ZipCd = '' 
    ma0_Sameas_Ba = '' 
    ma0_Commerical = '' 
    ma1_Str_Nbr = '' 
    ma1_Str_Nbr_Frac = '' 
    ma1_Str_Dir_Prefix = '' 
    ma1_Str_Nm = '' 
    ma1_Str_Dir_Suffix = '' 
    ma1_Str_Type = '' 
    mA2_Unit_Type = '' 
    ma2_Unit_Nbr = '' 
    ma2_CareOf = '' 
    ma3_City = '' 
    ma3_State = '' 
    ma3_ZipCd = '' 
    modified_By = '' 
    modified_Dt = '' 
    created_By = '' 
    created_Dt = '' 
    exemption_Id = ''
    postMarkDt : any
    registration_Number = ""
    location_Acct_Number = ""
    user = ""
    timeStampCurrent = ""
    ssn = ""
    fein = ""
    outside_boundary_flag = ""
    address_status = ""
	pastDate = ""
	//INC0754669 - Enhancement - PFA EappReg - Adding GGR
	ggr = ''
}